<template>
  <div class="operationCenter_container"
  >
    <div class="overal_bg"></div>
   <main class="index_page" :class="{ isThinStyle: isThin }">
     <div class="left_mod">
      <left-mod></left-mod>
     </div>
     <div class="center_mod">
       <center-mod></center-mod>
     </div>
     <div class="right_mod">
       <right-mod></right-mod>
     </div>
   </main>
  </div>
</template>

<script>
import leftMod from '@/modules/operationCenterComponents/leftMod';
import rightMod from '@/modules/operationCenterComponents/rightMod';
import centerMod from '@/modules/operationCenterComponents/centerMod';
export default {
  name: 'operationCenter',
  components: {leftMod,rightMod,centerMod},
  data() {
    return {
      styleType: '',
      isThin: bmeConfig.isThin,
    }
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.operationCenter_container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  pointer-events: auto;
  .overal_bg {
    position: absolute;
    left: 15px;
    top: 120px;
    bottom: 15px;
    right: 1px;
    background-image: url("/static/images/common/mask.png");
    background-size: 100% 100%;
    background-repeat: "no-repeat";
    z-index: -1;
  }
}

.index_page {
  height: 100%;
  position: relative;

  .left_mod {
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 160px;
    width: 20%;
    height: 800px;
    padding-left: 50px;
  }

  .center_mod {
    position: absolute;
    left: 20%;
    top: 0;
    margin-top: 160px;
    width: 60%;
    height: 800px;
  }

  .right_mod {
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 160px;
    width: 20%;
    height: 800px;
    padding-right: 50px;
  }
}
.isThinStyle {
  transform: scale(1, 0.8) !important;
}

</style>
